import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  updateList = new Subject();

  onUpdate(): Observable<any> {
    return this.updateList.asObservable();
  }

  triggerUpdate() {
    this.updateList.next({});
  }
}
